import React from "react";
import { OVERVIEW } from "../../../core/theme/reportTheme";

// A column heading that sorts its table (rules in core/data/sortRows.js).
// Arrow: ↓ big to small, ↑ small to big; ↕ on columns not sorted.
// sort: the active { column, dir }, or null for the table's default order.
export default function SortButton({ column, label, sort, onSort }) {
  const active = Boolean(sort) && sort.column === column;
  return (
    <button type="button" onClick={() => onSort(column)} className={active ? OVERVIEW.sortActive : OVERVIEW.sort}>
      {label}
      <span className={active ? "" : "opacity-40"}>{active ? (sort.dir === "asc" ? "↑" : "↓") : "↕"}</span>
    </button>
  );
}
